import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import _ from 'lodash';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, 
    ToastModule,
    TranslateModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('gigantix-frontend');

  constructor(
    private primeConfig: PrimeNG,
    private translate: TranslateService,
  ){
    // set navigator lang
    this.setNavigatorLang();
    // set ng-prime translations
    this.translate.get('primeng').subscribe(res => this.primeConfig.setTranslation(res));
  }

  private setNavigatorLang(): void {
    const navLang = navigator.language ? _.first(_.split(navigator.language, '-')) : null;
    const langToSet = navLang ? navLang : 'es';
    this.translate.use(langToSet || 'es');
  }
}
